import { useEffect, useState } from 'react';
import { Tab, TabProps } from '@mui/material';
import { useUi } from 'hooks/useUi';
import { verticalHeightBreakpoint } from 'lib/constants';

const verticallyCompressedTabStyle = {
    minHeight: '25px',
    padding: '0',
    maxWidth: '140px',
    fontSize: '0.8rem',
    marginRight: '10px',
    marginTop: '5px',
};

export const TuTab = (props: TabProps) => {
    const { ui } = useUi();
    const [shouldMinimize, setShouldMinimize] = useState(false);
    useEffect(() => {
        if (ui.height < verticalHeightBreakpoint) setShouldMinimize(true);
        else setShouldMinimize(false);
    }, [ui.height]);

    return shouldMinimize ? (
        <Tab
            data-testid="TuTab"
            iconPosition="start"
            sx={{ ...props.sx, ...verticallyCompressedTabStyle }}
            {...props}
        />
    ) : (
        <Tab data-testid="TuTab" {...props} />
    );
};
